(function () {
  'use strict';
  if (window.PPSubscriptionUI) return;
  window.PPSubscriptionUI = true;
  const instances = new WeakMap();
  const text = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  const parse = html => {
    const div = document.createElement('div');
    div.innerHTML = html || '';
    return div.textContent.trim();
  };
  function mount(config, widget) {
    widget.classList.add('pp-sub-ui');
    if (config.bags) widget.classList.add('pp-sub-ui--bags');
    const group = window.PPSubscriptionConfig?.groups.find(g => g.products.includes(config.product));
    const terms = new Map(config.plans.map(plan => {
      const holder = document.createElement('div');
      holder.innerHTML = plan.description || '';
      const spans = [...holder.querySelectorAll('span')];
      const last = spans.filter(span => /Eligible first.*(?:then|delivery)/i.test(span.textContent)).pop();
      return [plan.id, (last ? last.textContent : parse(plan.description)).replace(/^\s*💰\s*/, '').trim()];
    }));
    let details;
    const refresh = () => {
      const card = widget.querySelector('[data-loop-widget-selling-plan-group]');
      const tooltip = widget.querySelector('.loop-w-btn-group-tooltip-container');
      if (!card || !tooltip) return;
      if (config.highlight && !card.querySelector('.pp-sub-highlight')) {
        widget.classList.add('pp-sub-ui--highlighted');
        card.classList.add('pp-sub-highlight-card');
        const badge = document.createElement('span');
        badge.className = 'pp-sub-highlight';
        badge.id = 'pp-sub-highlight-' + config.product;
        const title = document.createElement('strong');
        title.className = 'pp-sub-highlight__title';
        const icon = document.createElement('span');
        icon.textContent = '🔥';
        icon.setAttribute('aria-hidden', 'true');
        title.append(icon, document.createTextNode(config.highlight.title));
        const detail = document.createElement('span');
        detail.className = 'pp-sub-highlight__detail';
        detail.textContent = config.highlight.detail;
        badge.append(title, detail);
        card.prepend(badge);
        const describedBy = (card.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (!describedBy.includes(badge.id)) describedBy.push(badge.id);
        card.setAttribute('aria-describedby', describedBy.join(' '));
      }

      const active = widget.querySelector('[data-selling-plan-id][aria-checked="true"]');
      const select = widget.querySelector('select');
      const planId = active?.dataset.sellingPlanId || select?.value || config.plans[0]?.id;
      const current = terms.get(planId) || terms.values().next().value || '';
      if (!current) return;
      if (!details || !tooltip.contains(details)) {
        details = document.createElement('details');
        details.className = 'pp-sub-details';
        const summary = document.createElement('summary');
        summary.textContent = config.labels.details;
        const content = document.createElement('div');
        content.className = 'pp-sub-details__content';
        const policy = document.createElement('p');
        policy.className = 'pp-sub-details__terms';
        const repeat = document.createElement('p');
        repeat.textContent = config.labels.repeat;
        content.append(policy, repeat);
        details.append(summary, content);
        tooltip.replaceChildren(details);
      }
      text(details.querySelector('.pp-sub-details__terms'), current);
      text(details.querySelector('.pp-sub-details__content p:last-child'), /Cancelling and resubscribing/.test(current) ? config.labels.repeat.replace(/^.*?\.\s*/, '') : config.labels.repeat);
      widget.querySelectorAll('.loop-w-btn-group-purchase-option-description-text span').forEach(span => {
        if (/Eligible first/i.test(span.textContent) && !span.hidden) {
          span.hidden = true;
          span.classList.add('pp-sub-moved-terms');
        }
      });
      if (config.bags) {
        widget.querySelectorAll('[data-selling-plan-id]').forEach(button => {
          const label = config.bags.frequencies[button.dataset.sellingPlanId];
          if (label) text(button, label);
        });
        widget.querySelectorAll('select option').forEach(option => {
          const label = config.bags.frequencies[option.value];
          if (label) text(option, label);
        });
        const frequency = widget.querySelector('.loop-w-btn-group-sp-button-selector-wrapper');
        const description = widget.querySelector('.loop-w-btn-group-purchase-option-description-text');
        if (frequency && description) {
          let usage = frequency.parentElement.querySelector('.pp-sub-bags-usage');
          if (!usage) {
            usage = document.createElement('p');
            usage.className = 'pp-sub-bags-usage';
            frequency.after(usage);
          }
          text(usage, config.bags.usage);
          description.querySelectorAll('span').forEach(span => {
            if (/Continuous monthly supply|Perfect refill pace/.test(span.textContent)) {
              text(span, '📦 ' + config.bags.refills);
            }
            if (/Best for multi-cat|Ideal for single-cat/.test(span.textContent)) {
              span.hidden = true;
              span.classList.add('pp-sub-bags-cat-guidance');
            }
          });
        }
        let minimum = widget.querySelector('.pp-sub-bags-minimum');
        if (!minimum) {
          minimum = document.createElement('p');
          minimum.className = 'pp-sub-bags-minimum';
          tooltip.before(minimum);
        }
        text(minimum, config.bags.minimum);
        minimum.hidden = card.getAttribute('aria-checked') !== 'true' || !/Minimum 2 orders/.test(current);
      }
      const renewal = current.match(/then\s+([^\.]*\d+\.\d{2}[^.]*)/i)?.[1];
      const eligible = config.currency === 'USD' && !group?.used && renewal;
      card.classList.toggle('pp-sub-offer', Boolean(eligible));
      let promo = card.querySelector('.pp-sub-promo');
      if (!eligible) { if (promo) promo.remove(); return; }
      if (!promo) {
        promo = document.createElement('div');
        promo.className = 'pp-sub-promo';
        for (const name of ['badge', 'price', 'eligible', 'renewal', 'check']) {
          const part = document.createElement(name === 'price' ? 'strong' : 'span');
          part.className = 'pp-sub-promo__' + name;
          promo.appendChild(part);
        }
        card.appendChild(promo);
      }
      text(promo.querySelector('.pp-sub-promo__badge'), config.labels.save.replace('{amount}', config.saving));
      text(promo.querySelector('.pp-sub-promo__price'), config.intro);
      text(promo.querySelector('.pp-sub-promo__eligible'), config.labels.eligible);
      const renewalAmount = renewal.match(/^\$\d+\.\d{2}/)?.[0];
      const renewalText = config.bags && renewalAmount
        ? config.bags.renewal.replace('{amount}', renewalAmount)
        : config.labels.then.replace('{renewal}', renewal);
      text(promo.querySelector('.pp-sub-promo__renewal'), renewalText);
      text(promo.querySelector('.pp-sub-promo__check'), /Minimum 2 orders/.test(current) ? config.labels.minimum : config.labels.check);
    };
    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; refresh(); });
    };
    const observer = new MutationObserver(schedule);
    observer.observe(widget, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['aria-checked']});
    widget.addEventListener('change', schedule);
    refresh();
    instances.set(widget, observer);
  }
  const scan = () => {
    document.querySelectorAll('[data-pp-subscription-ui]').forEach(node => {
      let config;
      try { config = JSON.parse(node.textContent); } catch (_) { return; }
      const widget = document.getElementById('loop-widget-container-id-' + config.product);
      if (widget && !instances.has(widget)) mount(config, widget);
    });
  };
  let pendingScan = false;
  new MutationObserver(() => {
    if (pendingScan) return;
    pendingScan = true;
    requestAnimationFrame(() => { pendingScan = false; scan(); });
  }).observe(document.body, {childList:true, subtree:true});
  scan();
})();
